import React from 'react';
import { MaskedInput } from 'antd-mask-input';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Input, Form, Row, Select, message, DatePicker, Col } from 'antd';
import {
  DrawerEdit,
  ResourceEdit,
  refreshAuthenticatedUser,
  FormItemWrap
} from 'react-structure-admin';
import { currentUserCancel, currentUserUpdate } from 'stores/users/userActions';
import {
  federalTaxNumberValidator,
  mobilePhoneValidator
} from 'util/validators/index';
import { CheckboxInput, ResCol, UploadProfileImageV2 } from 'components';
import usePermissions from 'core/hooks/usePermissions';

const CurrentUserEdit = (props) => {
  const { data, loading } = props;
  const dispatch = useDispatch();
  const { isPartnership } = usePermissions();

  const handleBeforeSubmit = ({ birthDate, address, ...rest }) => {
    return {
      ...rest,
      birthDate: birthDate ? moment(birthDate).format('YYYY/MM/DD') : null
    };
  };

  const handleBeforeBinding = ({ birthDate, address = {}, ...rest }) => {
    return {
      ...rest,
      birthDate: birthDate ? moment(birthDate) : null
    };
  };

  const onAfterUpdate = (response) => {
    if (response && response.data) {
      const { result } = response.data;
      dispatch(
        refreshAuthenticatedUser({
          name: result.name,
          displayName: result.displayName,
          profileImage: result.profileImage
        })
      );
    }

    message.success('Registro salvo com sucesso.');
  };

  const handleSubmit = (data) => {
    const values = handleBeforeSubmit(data);
    dispatch(currentUserUpdate(values, onAfterUpdate));
  };

  const handleCancel = () => {
    dispatch(currentUserCancel());
  };

  return (
    <DrawerEdit
      {...props}
      data={data}
      title="Meus dados"
      saving={loading}
      onSubmit={handleSubmit}
      cancelEdit={handleCancel}
      onAfterUpdate={onAfterUpdate}
      onBeforeBinding={handleBeforeBinding}
      size="md"
    >
      <Form>
        <Row>
          <Col flex={1}>
            <Row>
              <ResCol>
                <FormItemWrap
                  name="federalTaxNumber"
                  label="CPF"
                  autoFocus
                  rules={[{ validator: federalTaxNumberValidator }]}
                >
                  <MaskedInput mask="111.111.111-11" />
                </FormItemWrap>
                <FormItemWrap name="name" label="Nome" required whitespace>
                  <Input maxLength={150} />
                </FormItemWrap>
                <FormItemWrap name="legalName" whitespace>
                  <CheckboxInput
                    placeholder="Nome civil"
                    hint="Informe o nome civil se for diferente do nome social"
                  >
                    <Input maxLength={150} />
                  </CheckboxInput>
                </FormItemWrap>
                <FormItemWrap name="email" label="E-mail" required type="email">
                  <Input maxLength={60} disabled={isPartnership} />
                </FormItemWrap>
              </ResCol>
            </Row>
          </Col>
          <Col span={7}>
            <div className="gx-flex-row gx-align-items-center gx-justify-content-center">
              <FormItemWrap name="profileImage">
                <UploadProfileImageV2 />
              </FormItemWrap>
            </div>
          </Col>
        </Row>
        <Row>
          <ResCol span={8}>
            <FormItemWrap
              name="phoneNumber"
              label="Celular"
              required
              rules={[{ validator: mobilePhoneValidator }]}
            >
              <MaskedInput mask="(11) 11111-1111" />
            </FormItemWrap>
          </ResCol>
          <ResCol span={8}>
            <FormItemWrap name="gender" label="Sexo" required>
              <Select
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option key="uninformed" value="uninformed">
                  Não informado
                </Select.Option>
                <Select.Option key="male" value="male">
                  Masculino
                </Select.Option>
                <Select.Option key="female" value="female">
                  Feminino
                </Select.Option>
              </Select>
            </FormItemWrap>
          </ResCol>
          <ResCol span={8}>
            <FormItemWrap name="birthDate" label="Data de nascimento">
              <DatePicker
                format="DD/MM/YYYY"
                disabledDate={(date) => moment(date).isAfter(moment())}
              />
            </FormItemWrap>
          </ResCol>
        </Row>
      </Form>
    </DrawerEdit>
  );
};

export default ResourceEdit.create(CurrentUserEdit, {
  resource: 'users',
  currentAttr: 'currentUser'
});
